/**
 * Cursorful — Screen Recorder with Auto Zoom
 *
 * Declares one web-accessible-resource entry (`/iframe.html`, plus `libav` and
 * `_favicon` globs) with no `use_dynamic_url`, matched only to `localhost` and to
 * every `cursorful.com` subdomain. The resource is not exposed to arbitrary pages, so
 * a fetch from any other origin fails at the network layer and proves nothing.
 *
 * From a cursorful.com origin the static `iframe.html` URL resolves whenever the
 * extension is installed, making it a conclusive per-origin signal.
 *
 * Manifest verified against version 2.4.6.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'eihpmapodnppeemkhkbhikmggfojdkjd';

export const cursorful: ExtensionDefinition = {
  id: ID,
  name: 'Cursorful - Screen Recorder with Auto Zoom',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 60_000,
  requiredOrigin: 'https://www.cursorful.com',
  notes:
    'One static WAR (iframe.html) scoped to cursorful.com subdomains and localhost, so ' +
    'only Cursorful\'s own site can detect it. No dynamic URL.',
  signals: [
    {
      id: 'war-iframe-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch iframe.html — the recorder UI iframe, exposed only to cursorful.com ' +
        'origins. Resolves at a fixed URL when installed.',
      weight: 1,
      run: () => probeFetch(ID, 'iframe.html'),
    },
  ],
};
